let sys = [
    {
        path: '/sys/sysconfig',
        name: 'sysconfig',
        component: () => import('@/views/sys/sysconfig.vue'),
        meta: {keepAlive: true, parentPath: 'sys'},
    },
    {
        path: '/sys/sysAdvertising',
        name: 'sysconfig',
        component: () => import('@/views/sys/sysAdvertising.vue'),
        meta: {keepAlive: true, parentPath: 'sys'},
    },
    {
        path: '/sys/quartzJob',
        name: 'quartzJob',
        component: () => import('@/views/sys/quartzJob.vue'),
        meta: {keepAlive: true, parentPath: 'sys'},
    }
    
]
export default sys


// WEBPACK FOOTER //
// ./src/router/sys.js